<template>
    <div v-if="animals != null && translationsLoaded" class="link-boxes animals-overview__link-boxes" :class="getModClass()">
        <span v-for="(item, index) in categorisedAnimals" :key="index" class="animals-overview__link-boxes-link link-boxes__link">
            <div class="link-boxes__top">
                <imageComponent :image="item.Image" :image-params="item.ImageParams" create-fallback="true" module-name="link-boxes" />
                <h2 class="link-boxes__headline">
                    {{ item.Name }}
                    <br />
                    <i>{{ getLatinName(item) }}</i>
                </h2>
                <span v-if="(getPlace(item) != null && getPlace(item) != '')" class="animals-overview__link-boxes-label link-boxes__label">{{ getPlace(item) }}</span>
            </div>
            <div class="link-boxes__bottom">
                <template v-if="item.TypeFields">
                    <span class="link-boxes__description link-boxes__description--list">
                        <template v-for="(typeField, typeFieldName, typeFieldIndex) in item.TypeFields" :key="typeFieldIndex">
                            <span class="link-boxes__description-label">{{ getFieldLabel(typeFieldName).Value }}</span> <span class="link-boxes__description-value">{{ typeField.Value }} {{ getFieldUnit(typeFieldName) }}</span>
                        </template>
                    </span>
                </template>
            </div>
        </span>
    </div>
</template>

<script>
window.animalsOverviewLaoded = false;
import { mapGetters } from 'vuex';
import imageComponent from '../components/image-component.vue';

export default {
    name: 'AnimalsOverview',
    components: {
        imageComponent
    },
    data() {
        return {
            animals: null,
            ecomLanguageId: document.documentElement.dataset.ecomLang,
            translationsLoaded: false
        };
    },
    computed: {
        ...mapGetters('translationStore', ['getTranslation', 'getTranslations', 'getTranslationsByCategory']),
        categorisedAnimals() {
            if (this.animals != null) {
                const returnAnimals = this.animals;

                this.animals.forEach(animal => {
                    // Detect aninmal type
                    const isFish = !!animal.ProductCategories.Fish;
                    const isBird = !!animal.ProductCategories.Birds;
                    const isInvertebrate = !!animal.ProductCategories.Invertebrates;
                    const isMarineMammal = !!animal.ProductCategories.MarineMammals;
                    let animalType = 'other';
                    animalType = isFish ? 'fish' : animalType;
                    animalType = isBird ? 'bird' : animalType;
                    animalType = isInvertebrate ? 'invertebrate' : animalType;
                    animalType = isMarineMammal ? 'marinemammal' : animalType;

                    animal.Type = animalType;

                    let animalTypeFields = null;

                    // Set type fields, so we don't need a lot of logic up in the template.
                    // This way we just need to iterate through "typefields" on the item / animal.
                    switch (animal.Type) {
                        case 'fish':
                            animalTypeFields = animal.FieldDisplayGroups ? (animal.FieldDisplayGroups.FishOverview ? animal.FieldDisplayGroups.FishOverview.Fields : null) : null;

                            break;
                        case 'bird':
                            animalTypeFields = animal.FieldDisplayGroups ? (animal.FieldDisplayGroups.BirdsOverview ? animal.FieldDisplayGroups.BirdsOverview.Fields : null) : null;

                            break;
                        case 'invertebrate':
                            animalTypeFields = animal.FieldDisplayGroups ? (animal.FieldDisplayGroups.InvertebratesOverview ? animal.FieldDisplayGroups.InvertebratesOverview.Fields : null) : null;

                            break;
                        case 'marinemammal':
                            animalTypeFields = animal.FieldDisplayGroups ? (animal.FieldDisplayGroups.MarineMammalsOverview ? animal.FieldDisplayGroups.MarineMammalsOverview.Fields : null) : null;

                            break;
                        default:
                            animalTypeFields = animal.FieldDisplayGroups ? (animal.FieldDisplayGroups.OthersOverview ? animal.FieldDisplayGroups.OthersOverview.Fields : null) : null;

                            break;
                    }

                    animal.TypeFields = animalTypeFields;

                    if (animal.AssetCategories) {
                        if (animal.AssetCategories.find(x => x.SystemName == 'Images')) {
                            if (animal.AssetCategories.find(x => x.SystemName == 'Images').Assets) {
                                animal.Image = {
                                    url: animal.AssetCategories.find(x => x.SystemName == 'Images').Assets[0].Value,
                                    hasFocalPoint: false,
                                    focalPointParameters: null,
                                    alternateText: animal.Name
                                };
                            }
                        }
                    }

                    animal.ImageParams = {
                        xxlParams: this.animals.length % 4 == 0 || this.animals.length > 12 ? '&width=520&height=532' : (this.animals.length % 3 == 0 ? '&width=698&height=532' : '&width=792&height=532'),
                        mdParams: this.animals.length % 4 == 0 || this.animals.length > 12 ? '&width=386&height=539' : (this.animals.length % 3 == 0 ? '&width=520&height=539' : '&width=789&height=539'),
                        xsParams: '&width=444&height=369',
                        defaultParams: '&width=433&height=360',
                    };
                });

                return returnAnimals;
            }

            return null;
        }
    },
    created() {
        const fetchUrl = `/dwapi/Feeds/GetFeedOutput?Id=4&languageId=${this.ecomLanguageId}`;

        fetch(fetchUrl)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                return response.json();
            })
            .then(data => {
                this.animals = data.Products;
            })
            .catch(error => {
                console.error('Fetch error:', error);
            });
    },
    beforeUnmount() {

    },
    async mounted() {
        await this.$store.dispatch('translationStore/fetchTranslations').then(() => {
            this.translationsLoaded = true;
        });

        window.animalsOverviewLaoded = true;
    },
    methods: {
        getModClass() {
            if (this.animals != null) {
                const modClass = this.animals.length % 4 == 0 || this.animals.length > 12 ? 'link-boxes--mod4' : (this.animals.length % 3 == 0 ? 'link-boxes--mod3' : '');
                return modClass;
            }

            return null;
        },
        getLatinName(animal) {
            if (animal.ProductCategories.GeneralInformationAnimals && animal.ProductCategories.GeneralInformationAnimals.Fields && animal.ProductCategories.GeneralInformationAnimals.Fields.LatinName && animal.ProductCategories.GeneralInformationAnimals.Fields.LatinName.Value) {
                return animal.ProductCategories.GeneralInformationAnimals.Fields.LatinName.Value;
            }

            return null;
        },
        getFieldLabel(fieldName) {
            return this.getTranslation(`Translate.UI.${fieldName}`);
        },
        getFieldUnit (fieldName) {
            switch (fieldName) {
                case 'LengthMax':
                case 'HabitatDepthMax':
                case 'WingSpanMax':
                    return 'm';
                case 'WeightMax':
                    return 'kg';
                default:
                    return `[${fieldName}]`;
            }
        },
        getPlace(animal) {
            if (animal.ProductCategories.GeneralInformationAnimals && animal.ProductCategories.GeneralInformationAnimals.Fields && animal.ProductCategories.GeneralInformationAnimals.Fields.FoundAtNorthSeaOceanarium && animal.ProductCategories.GeneralInformationAnimals.Fields.FoundAtNorthSeaOceanarium.Value) {
                if (animal.ProductCategories.GeneralInformationAnimals.Fields.FoundAtNorthSeaOceanarium.Value == true) {
                    if (animal.ProductCategories.GeneralInformationAnimals.Fields.SpeciesAquarium && animal.ProductCategories.GeneralInformationAnimals.Fields.SpeciesAquarium.Value) {
                        return `${this.getTranslation('Translate.UI.CanBeExperiencedAt').Value} ${animal.ProductCategories.GeneralInformationAnimals.Fields.SpeciesAquarium.Value.map(x => x.Value).join(', ')}`;
                    }
                }
            }

            return null;
        }
    }
};
</script>
